module.exports = __webpack_public_path__ + "static/media/BestAutoTechAward.eec5396f.png";